module.exports = __webpack_public_path__ + "static/media/clue0203.a0f82ede.jpg";